import React from 'react'
import Button from '../../../components/button/button'
import { toRoute } from "../../../i18n"
import '../styles/jobCard_style.css'

export default function JobCard({ data, onClick, width = 352 }) {

  return (
    <div className="card-container" style={{ width: width }}>
      <p className="card-title">{data.title}</p>
      <p className="card-subtitle">{data.subtitle}</p>
      <p className="card-status">{data.status}</p>
      <Button asLink={true} to={toRoute(`/career/${data.id}`)} height={45} title="Apply this jobs" onClick={onClick} />
    </div>
  )

}
